import React from 'react';

export function ClickAndPress () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.244 15v-2a1.5 1.5 0 011.5-1.5v0a1.5 1.5 0 011.5 1.5v4.087a9.312 9.312 0 01-1.171 4.522l-.912 1.641a3.31 3.31 0 00-.417 1.608v1.667a.975.975 0 01-.974.975h-7.128a.898.898 0 01-.897-.898v-1.835a.57.57 0 00-.206-.438v0a25.085 25.085 0 01-4.813-5.356l-1.132-1.699a1.67 1.67 0 01.346-2.23v0a1.67 1.67 0 012.348.26L11.245 19V7a1.5 1.5 0 011.5-1.5v0a1.5 1.5 0 011.5 1.5v8"
      />
      <path
        stroke="#717171"
        d="M17.245 15v-3.175a1.5 1.5 0 00-1.5-1.5v0a1.5 1.5 0 00-1.5 1.5V15"
      />
      <path
        stroke="#717171"
        strokeLinecap="round"
        d="M20.245 15v-2.672a1.5 1.5 0 10-3 0V15M16.245 6.5a3.5 3.5 0 10-7 0M8.332 10.566a6 6 0 1110.365-3.304"
      />
    </svg>
  );
}
